<form [formGroup]="testForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Переименование теста</h3>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>Название теста</mat-label>
      <input matInput formControlName="name" placeholder="Укажите название теста"
             autocomplete="off" cdkFocusInitial>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Сохранить
    </button>
  </div>
</form>
